import React from 'react';
import { motion } from 'framer-motion';
export function ProblemReframe() {
  return <section className="py-20 bg-[#fef3e2] px-4" data-id="element-154">
      <div className="max-w-3xl mx-auto text-center" data-id="element-155">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-156">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-8" data-id="element-157">
            La verdad incómoda
          </h2>

          <p className="text-xl text-slate-700 mb-8 leading-relaxed" data-id="element-158">
            La mayoría de soluciones fallan por una razón simple:
            <br data-id="element-159" />
            <span className="font-bold text-slate-900 block mt-2 text-2xl" data-id="element-160">
              Tratan el sueño como un acto de voluntad.
            </span>
          </p>

          <div className="bg-white/60 p-8 rounded-2xl shadow-sm mb-8" data-id="element-161">
            <p className="text-lg text-slate-600 mb-4" data-id="element-162">
              Como si dormir fuera: "haz más disciplina, relájate, piensa
              positivo".
            </p>
            <p className="text-lg text-slate-600" data-id="element-163">
              Pero en mujeres 45+ el problema muchas veces es otro:
            </p>
            <p className="text-2xl font-bold text-[#0d9488] mt-4 font-serif" data-id="element-164">
              Tu sistema nervioso se queda encendido.
            </p>
          </div>

          <p className="text-lg text-slate-700" data-id="element-165">
            Y cuando se enciende, tu mente hace lo único que sabe: <br data-id="element-166" />
            <span className="font-semibold" data-id="element-167">
              buscar peligro, buscar control, buscar explicación.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}